module.exports = __webpack_public_path__ + "assets/img/37_1542.d381a486.jpg";